<script lang="ts">
    import { useNavigate } from "svelte-navigator";
    import {
        ContentListEntry,
        UserResponse,
    } from "../../../../../../admin-service-typescript-client";

    const navigate = useNavigate();
    export let contentEntry: ContentListEntry;

    let openDropdown: boolean = false;

    let userDetails: UserResponse;
</script>

<div class="column is-12">
    <div class="columns is-vcentered">
        <div class="column is-2 username" />
        <div class="column is-3 username">
            {contentEntry.name}
        </div>
        <div class="column is-3">
            {contentEntry.releaseStatus}
        </div>
        <div class="column is-3">
            <video
                width="120"
                controls={true}
                preload="metadata"
                src={contentEntry.url}
            />
        </div>
        <!-- <div class="column is-1">
                        {#if !openDropdown}
                            <span
                                class="icon"
                                on:click={() => {
                                    getUser();
                                    openDropdown = !openDropdown;
                                }}
                            >
                                <i class="fas fa-angle-down" />
                            </span>
                        {/if}

                        {#if openDropdown}
                            <span
                                class="icon"
                                on:click={() => {
                                    getUser();
                                    openDropdown = !openDropdown;
                                }}
                            >
                                <i class="fas fa-angle-up" />
                            </span>
                        {/if}
                    </div> -->
    </div>
</div>

<style>
    .card {
        margin: 5px 0;
    }

    .image,
    .icon {
        cursor: pointer;
    }
    .column {
        overflow: hidden;
        text-overflow: ellipsis;
        text-align: center;
    }

    .box {
        height: 100%;
    }

    .username {
        color: darkblue;
    }

    /* unvisited link */
    .username:link {
        color: darkblue;
    }

    /* visited link */
    .username:visited {
        color: darkblue;
    }

    /* mouse over link */
    .username:hover {
        color: darkblue;
        cursor: pointer;
    }

    /* selected link */
    .username:active {
        color: darkblue;
    }
</style>
